import React, {Component} from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import TableHeader from "../../../../components/TableHeader/index";
import PageHeader from "../../../../components/PageHeader";
import Pagination from "../../../../components/Pagination";
import {checkViewPermission} from "../../../../utils/common";
import PublicSecureAuthorization
    from "../../../../services/system/secure-authorization/secure-authorization-controller";
import ModalCreateAdmissions from "./modalCreateAdmissions";
import ModalEditAdmissions from "./modalEditAdmissions";
import ModalDeleteAdmissions from "./modalDeleteAdmissions";
import CampaignController from "../../../../services/qlts/campaign-controller";
import {toast} from "react-toastify";
import {getSchoolYear} from "../../../../utils/authority";

class AdmissionsManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listData: [],
            pageNumber: 0,
            pageSize: 10,
            page: 0,
            code: "",
            status: "",
            sort: 'id',
            descending: 'DESC',
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên chiến dịch",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "des",
                    name: "Miêu tả",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "link",
                    name: "Link chiến dịch",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "type",
                    name: "Loại quảng cáo",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "status",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "",
                    name: "Thao tác",
                    style: {minWidth: 120, textAlign: "center"},
                    sort: false
                }
            ]
        };
    }

    componentDidMount() {
        // this.onhandleSearch();
        this.setState({showLoading: true},
            () => this.getListCampaign()
        )
        this.getListGroupUser()
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    // ---------------------------------------------------------------------------------------------------------

    getListCampaign() {
        let payload = {
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            yearId: parseInt(getSchoolYear()),
            "sort": "created_at desc"
        };
        console.log("getListCampaign")
        CampaignController.getList(payload, res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listData: res.data.content,
                        totalItem: res.data.totalElements,
                        totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                        showLoading: data.length < 0
                    }
                );
            } else {
            }
        });
    }
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListContractFromAPI();
            }
        );
    };
    render() {
        let {listData, pageNumber, header} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="enrollment-campaign" parentClass="admissions-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý chiến dịch tuyển sinh"/>
                                </div>
                                <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                    <div className="row">
                                        <div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"
                                             style={{
                                                 alignItems: "center",
                                                 justifyContent: "right"
                                             }}>
                                            {checkViewPermission("QLTS_CAMPAIGN_ADD") &&
                                                <button
                                                    style={{height: 35, marginRight: 12, marginBottom: 8}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.setState({showModalCreate: true})}
                                                >
                                                    Thêm mới
                                                </button>
                                            }
                                        </div>
                                    </div>
                                </form>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>

                                                            <td style={{textAlign: "left"}}>
                                                                {row.name}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.description}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                <button className="btn btn-action p-2"
                                                                        title='Sửa'
                                                                        style={{cursor: 'pointer'}}
                                                                        onClick={() => {
                                                                            let link = row.link+"?id="+row.id
                                                                            navigator.clipboard.writeText(link);
                                                                            toast.success("Đã copy: "+link, {
                                                                                position: toast.POSITION.TOP_RIGHT,
                                                                                autoClose: 3000
                                                                            });
                                                                        }}
                                                                >
                                                                    <i className="fa fa-copy"/>
                                                                </button>
                                                                <a target="_blank" href={row.link+"?id="+row.id}>{row.link}?id={row.id}</a>
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.sourceCampaign}
                                                            </td>
                                                            <td style={{textAlign: "left"}}>
                                                                {row.status=="INACTIVE" ? <span className="badge badge-danger" style={{color: "white"}}>Khóa</span> : <span className="badge badge-success" style={{color: "white"}}>Hoạt động</span>}
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {checkViewPermission("QLTS_CAMPAIGN_EDIT") &&
                                                                    <button className="btn btn-action p-2"
                                                                            title='Sửa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.id, showModalEdit: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-pencil-alt"/>
                                                                    </button>
                                                                }
                                                                {checkViewPermission("QLTS_CAMPAIGN_DELETE") &&
                                                                    <button className="btn btn-action p-2"
                                                                            title='Xóa'
                                                                            style={{cursor: 'pointer'}}
                                                                            onClick={() => {
                                                                                this.setState({itemSelected: row.id, showModalDelete: true})
                                                                            }}
                                                                    >
                                                                        <i className="ti-trash"/>
                                                                    </button>
                                                                }
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalCreateAdmissions
                    show={this.state.showModalCreate}
                    onHide={() => this.setState({showModalCreate: false})}
                    onRefresh={() => this.getListCampaign()}
                    id={this.state.itemSelected}
                />
                <ModalEditAdmissions
                    show={this.state.showModalEdit}
                    onHide={() => this.setState({showModalEdit: false})}
                    onRefresh={() => this.getListCampaign()}
                    id={this.state.itemSelected}
                />
                <ModalDeleteAdmissions
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.getListCampaign()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default AdmissionsManagement;
